/* Local Nurse Bound behavior. No checkout or external submissions. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-local-form]').forEach(form => {
    form.addEventListener('submit', event => {
      event.preventDefault();
      const message = form.parentElement.querySelector('.mb-footer__msg');
      if (message) { message.textContent = 'Die Anmeldung ist in dieser lokalen Vorschau noch nicht verbunden.'; message.style.display = 'block'; }
    }, true);
  });
  const search = document.querySelector('#nb-search');
  if (search) {
    search.value = new URLSearchParams(location.search).get('q') || '';
    const filter = () => {
      const query = search.value.trim().toLocaleLowerCase('de');
      let count = 0;
      document.querySelectorAll('.nb-product-card').forEach(card => {
        const show = card.textContent.toLocaleLowerCase('de').includes(query);
        card.hidden = !show; card.style.display = show ? '' : 'none'; if (show) count++;
      });
      document.querySelector('#nb-search-empty').hidden = count > 0;
    };
    search.addEventListener('input', filter); filter();
  }
});
